import React, { useState, useEffect } from 'react';
import Header from './Header';
import API_URL from '../config';
import logo from '../logo.svg';
import { FaSearch } from 'react-icons/fa';
import EmpresaUsuariosPage from './EmpresaUsuariosPage';
import EmpresaFinalizadorasPage from './EmpresaFinalizadorasPage';
import EmpresaLicencasPage from './EmpresaLicencasPage';
import RevendaConfiguracaoPage from './RevendaConfiguracaoPage';

// Funções de máscara e validação
function maskCpfCnpj(value) {
  value = value.replace(/\D/g, '');
  if (value.length <= 11) {
    // CPF: 000.000.000-00
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  } else {
    // CNPJ: 00.000.000/0000-00
    value = value.replace(/(\d{2})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d)/, '$1/$2');
    value = value.replace(/(\d{4})(\d{1,2})$/, '$1-$2');
  }
  return value;
}

function maskIeRg(value) {
  return value.replace(/\D/g, '');
}

function maskTelefone(value) {
  value = value.replace(/\D/g, '');
  if (value.length <= 10) {
    // (99)9999-9999
    value = value.replace(/(\d{2})(\d)/, '($1)$2');
    value = value.replace(/(\d{4})(\d)/, '$1-$2');
  } else {
    // (99)99999-9999
    value = value.replace(/(\d{2})(\d)/, '($1)$2');
    value = value.replace(/(\d{5})(\d)/, '$1-$2');
  }
  return value;
}

function maskCep(value) {
  value = value.replace(/\D/g, '');
  value = value.replace(/(\d{5})(\d)/, '$1-$2');
  return value.slice(0, 9);
}

// Função de máscara monetária brasileira para percentuais
function maskPercentBR(value) {
  value = value.replace(/\D/g, '');
  if (!value) return '';
  value = (parseInt(value, 10) / 100).toFixed(2);
  return value.replace('.', ',');
}

// Função para identificar e mascarar documento
function getDocumentoLabelValor(documento) {
  const doc = (documento || '').replace(/\D/g, '');
  if (doc.length === 14) {
    return { label: 'CNPJ', valor: maskCpfCnpj(doc) };
  } else if (doc.length === 11) {
    return { label: 'CPF', valor: maskCpfCnpj(doc) };
  }
  return { label: 'Documento', valor: documento };
}

function RevendaEmpresasPage({ usuario, empresa, onVoltar, onSair }) {
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [modalAberto, setModalAberto] = useState(false);
  const [modalInfo, setModalInfo] = useState(null);
  const [form, setForm] = useState({
    id: null,
    documento: '',
    ie_rg: '',
    indicador_ie: '',
    razao: '',
    fantasia: '',
    email: '',
    telefone: '',
    path_imagem: '',
    senha_cert: '',
    vencimento_cert: '',
    csc_id: '',
    csc: '',
    certificado: null, // arquivo
    // Endereço
    cep: '',
    rua: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    estado: '',
    ibge: '',
    interface: '',
    token: '',
    utiliza_tabelas_precos: false,
    tabelas_precos: [],
    taxa_servico: '',
    taxa_percentual: '',
    cash_percentual: '',
    autopagamento: false,
    gerenciar_impressao: false,
    ativo: true,
  });
  const [editando, setEditando] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [pesquisa, setPesquisa] = useState('');
  const [pagina, setPagina] = useState(1);
  const [uploading, setUploading] = useState(false);
  const [confirmarExclusao, setConfirmarExclusao] = useState({ aberto: false, id: null });
  const [buscandoCnpj, setBuscandoCnpj] = useState(false);
  const [buscandoCep, setBuscandoCep] = useState(false);
  const [alerta, setAlerta] = useState(null);
  const [tabelasPrecos, setTabelasPrecos] = useState([]);
  const [paginaUsuarios, setPaginaUsuarios] = useState(false);
  const [empresaSelecionada, setEmpresaSelecionada] = useState(null);
  const [paginaFinalizadoras, setPaginaFinalizadoras] = useState(false);
  const [paginaLicencas, setPaginaLicencas] = useState(false);
  const [showConfiguracao, setShowConfiguracao] = useState(false);

  const PAGE_SIZE = 12;

  useEffect(() => {
    fetchEmpresas();
    // eslint-disable-next-line
  }, [empresa.id]);

  const fetchEmpresas = async () => {
    setLoading(true);
    setErro('');
    try {
      const res = await fetch(`${API_URL}/pessoas?revenda_id=${empresa.id}&todas=true`);
      const data = await res.json();
      setEmpresas(Array.isArray(data) ? data : []);
    } catch {
      setEmpresas([]);
      setErro('Erro ao buscar empresas');
    }
    setLoading(false);
  };

  // Função para gerar token
  const gerarToken = (id) => {
    if (id) {
      const idStr = String(id).padStart(5, '0');
      const random = Math.floor(Math.random() * 10000000000).toString().padStart(10, '0');
      return idStr + random;
    } else {
      // Gera um token aleatório de 15 dígitos se não houver ID
      let token = '';
      for (let i = 0; i < 15; i++) {
        token += Math.floor(Math.random() * 10);
      }
      return token;
    }
  };

  const abrirModal = (empresa = null) => {
    if (empresa) {
      let path_imagem = empresa.path_imagem || '';
      if (path_imagem && !path_imagem.startsWith('https://')) {
        path_imagem = `https://conexaopix.com.br/docs${path_imagem}`;
      }
      // Gerar token se não existir
      const token = empresa.token || gerarToken(empresa.id);
      setForm({
        id: empresa.id,
        documento: empresa.documento ? maskCpfCnpj(empresa.documento) : '',
        ie_rg: empresa.ie_rg || '',
        indicador_ie: empresa.indicador_ie !== undefined && empresa.indicador_ie !== null ? String(empresa.indicador_ie) : '',
        razao: empresa.razao || '',
        fantasia: empresa.fantasia || '',
        email: empresa.email || '',
        telefone: empresa.telefone ? maskTelefone(empresa.telefone) : '',
        path_imagem,
        senha_cert: empresa.senha_cert || '',
        vencimento_cert: empresa.vencimento_cert 
          ? new Date(empresa.vencimento_cert).toISOString().slice(0, 10) 
          : '',
        csc_id: empresa.csc_id || '',
        csc: empresa.csc || '',
        certificado: null,
        cep: empresa.endereco?.cep ? maskCep(empresa.endereco.cep) : '',
        rua: empresa.endereco?.rua || '',
        numero: empresa.endereco?.numero || '',
        complemento: empresa.endereco?.complemento || '',
        bairro: empresa.endereco?.bairro || '',
        cidade: empresa.endereco?.cidade || '',
        estado: empresa.endereco?.estado || '',
        ibge: empresa.endereco?.ibge || '',
        interface: empresa.interface || '',
        token: token,
        utiliza_tabelas_precos: empresa.utiliza_tabelas_precos || false,
        tabelas_precos: empresa.tabelas_precos ? String(empresa.tabelas_precos).split(',').map(s => s.trim()).filter(Boolean) : [],
        taxa_servico: empresa.taxa_servico || '',
        taxa_percentual: empresa.taxa_percentual || '',
        cash_percentual: empresa.cash_percentual || '',
        autopagamento: empresa.autopagamento || false,
        gerenciar_impressao: empresa.gerenciar_impressao || false,
        ativo: empresa.ativo !== undefined ? empresa.ativo : true,
      });
      // Buscar tabelas de preços se for edição
      fetchTabelasPrecos(empresa.id);
      setEditando(true);
    } else {
      setForm({
        id: null,
        documento: '',
        ie_rg: '',
        indicador_ie: '',
        razao: '',
        fantasia: '',
        email: '',
        telefone: '',
        path_imagem: '',
        senha_cert: '',
        vencimento_cert: '',
        csc_id: '',
        csc: '',
        certificado: null,
        cep: '',
        rua: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        ibge: '',
        interface: '',
        token: gerarToken(),
        utiliza_tabelas_precos: false,
        tabelas_precos: [],
        taxa_servico: '',
        taxa_percentual: '',
        cash_percentual: '',
        autopagamento: false,
        gerenciar_impressao: false,
        ativo: true,
      });
      setEditando(false);
    }
    setErro('');
    setModalAberto(true);
  };

  const fecharModal = () => {
    setModalAberto(false);
    setForm({
      id: null,
      documento: '',
      ie_rg: '',
      indicador_ie: '',
      razao: '',
      fantasia: '',
      email: '',
      telefone: '',
      path_imagem: '',
      senha_cert: '',
      vencimento_cert: '',
      csc_id: '',
      csc: '',
      certificado: null,
      cep: '',
      rua: '',
      numero: '',
      complemento: '',
      bairro: '',
      cidade: '',
      estado: '',
      ibge: '',
      interface: '',
      token: '',
      utiliza_tabelas_precos: false,
      tabelas_precos: [],
      taxa_servico: '',
      taxa_percentual: '',
      cash_percentual: '',
      autopagamento: false,
      gerenciar_impressao: false,
      ativo: true,
    });
    setEditando(false);
    setErro('');
    setSalvando(false);
  };

  // Verificação de CNPJ/CPF duplicado
  const verificarCnpjExistente = async (documento, idAtual = null) => {
    const docLimpo = documento.replace(/\D/g, '');
    if (docLimpo.length < 11) return;
    try {
      const res = await fetch(`${API_URL}/pessoas?revenda_id=${empresa.id}`);
      const empresas = await res.json();
      const existe = empresas.some(e => String(e.documento) === docLimpo && (!idAtual || e.id !== idAtual));
      if (existe) {
        setErro('');
        setAlerta('Empresa já cadastrada!');
        setTimeout(() => {
          setAlerta(null);
          fecharModal();
        }, 2000);
        return true;
      } else {
        setErro('');
        return false;
      }
    } catch {
      setErro('Erro ao verificar CNPJ/CPF existente!');
      return false;
    }
  };

  const handleChange = e => {
    const { name, value, type, files } = e.target;
    if (type === 'file') {
      setForm(f => ({ ...f, [name]: files[0] }));
    } else {
      if (name === 'documento') {
        let v = value.replace(/\D/g, '').slice(0, 14);
        setForm(f => ({ ...f, documento: maskCpfCnpj(v) }));
        if (!editando) {
          verificarCnpjExistente(v);
        }
      } else if (name === 'ie_rg') {
        setForm(f => ({ ...f, ie_rg: maskIeRg(value) }));
      } else if (name === 'telefone') {
        let v = value.replace(/\D/g, '').slice(0, 11);
        setForm(f => ({ ...f, telefone: maskTelefone(v) }));
      } else if (name === 'cep') {
        let v = value.replace(/\D/g, '').slice(0, 8);
        setForm(f => ({ ...f, cep: maskCep(v) }));
      } else if (name === 'tabelas_precos') {
        const options = Array.from(e.target.selectedOptions).map(opt => opt.value);
        setForm(f => ({ ...f, tabelas_precos: options }));
      } else if (name === 'utiliza_tabelas_precos') {
        setForm(f => ({ ...f, utiliza_tabelas_precos: e.target.checked }));
      } else if (name === 'taxa_percentual' || name === 'cash_percentual') {
        setForm(f => ({ ...f, [name]: maskPercentBR(value) }));
      } else {
        // Sempre salvar em maiúsculo para campos de texto
        const upperValue = typeof value === 'string' ? value.toUpperCase() : value;
        setForm(f => ({ ...f, [name]: upperValue }));
      }
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setErro('');
    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('revenda_id', empresa.id);
    try {
      const res = await fetch(`${API_URL}/upload-empresa-logo`, {
        method: 'POST',
        body: formData
      });
      if (!res.ok) throw new Error('Erro ao fazer upload');
      const data = await res.json();
      setForm(f => ({ ...f, path_imagem: data.path }));
    } catch (err) {
      setErro('Erro ao fazer upload da imagem');
    }
    setUploading(false);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setErro('');
    if (!form.documento || !form.razao || !form.fantasia) {
      setErro('Preencha os campos obrigatórios!');
      return;
    }
    setSalvando(true);
    // Limpar documento, telefone, ie_rg e cep
    const docLimpo = form.documento.replace(/\D/g, '');
    const telLimpo = form.telefone.replace(/\D/g, '');
    const ieRgLimpo = form.ie_rg.replace(/\D/g, '');
    const cepLimpo = form.cep.replace(/\D/g, '');
    // Converter para maiúsculas/minúsculas
    const razao = form.razao.toUpperCase();
    const fantasia = form.fantasia.toUpperCase();
    const email = form.email.toLowerCase();
    // Verificar CNPJ/CPF duplicado (ignorar a própria empresa ao editar)
    const existe = await verificarCnpjExistente(docLimpo, editando ? form.id : null);
    if (existe) {
      setSalvando(false);
      return;
    }
    if (uploading) {
      setErro('Aguarde o upload da imagem!');
      setSalvando(false);
      return;
    }
    try {
      let pessoa = '';
      if (docLimpo.length === 14) pessoa = 'J';
      else if (docLimpo.length === 11) pessoa = 'F';
      // Forçar path_imagem com domínio completo
      let path_imagem = form.path_imagem || '';
      if (path_imagem && !path_imagem.startsWith('https://')) {
        path_imagem = `https://conexaopix.com.br/docs${path_imagem}`;
      }
      // Gerar token se não existir
      const token = form.token || gerarToken(form.id);
      // Garantir formato yyyy-MM-dd para vencimento_cert
      const vencimentoCertFormatado = form.vencimento_cert
        ? new Date(form.vencimento_cert).toISOString().slice(0, 10)
        : '';
      const tabelasPrecosString = Array.isArray(form.tabelas_precos) ? form.tabelas_precos.join(',') : '';
      const dados = {
        ...form,
        razao,
        fantasia,
        email,
        vencimento_cert: vencimentoCertFormatado,
        token,
        servidor_id: 1,
        documento: docLimpo, // Enviar SEM máscara
        telefone: telLimpo, // Enviar SEM máscara
        ie_rg: ieRgLimpo, // Enviar SEM máscara
        cep: cepLimpo, // Enviar SEM máscara
        empresa: true,
        revenda_id: empresa.id,
        pessoa,
        path_imagem,
        tabelas_precos: tabelasPrecosString,
        usuario_id: usuario.usr_codigo || usuario.id // <-- Enviar id do usuário logado
      };
      const formData = new FormData();
      Object.entries(dados).forEach(([k, v]) => {
        if (v !== null && v !== undefined) formData.append(k, v);
      });
      const method = editando ? 'PUT' : 'POST';
      const url = editando ? `${API_URL}/pessoas/${form.id}` : `${API_URL}/pessoas`;
      const res = await fetch(url, {
        method,
        body: formData,
      });
      if (!res.ok) throw new Error('Erro ao salvar empresa');
      const data = await res.json();
      
      if (!editando) {
        // LOG para depuração
        console.log('Dados recebidos do backend ao criar empresa:', data);
        setModalInfo({
          empresa_id: data.id,
          usuario_id: data.usr_codigo,
          senha: data.senha,
          token: data.token,
          rev_carencia: data.rev_carencia,
          rev_validade: data.rev_validade,
          app_grupo_id: data.app_grupo_id
        });
      }
      
      fecharModal();
      fetchEmpresas();
    } catch (err) {
      setErro(err.message || 'Erro ao salvar empresa');
      setSalvando(false);
    }
  };

  const handleDelete = async id => {
    setConfirmarExclusao({ aberto: true, id });
  };

  const confirmarRemocao = async () => {
    try {
      await fetch(`${API_URL}/pessoas/${confirmarExclusao.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ativo: false }),
      });
      fetchEmpresas();
    } catch {
      setErro('Erro ao desativar empresa');
    }
    setConfirmarExclusao({ aberto: false, id: null });
  };

  const cancelarRemocao = () => {
    setConfirmarExclusao({ aberto: false, id: null });
  };

  // Filtro de pesquisa
  const empresasFiltradas = empresas.filter(e =>
    (e.razao || '').toLowerCase().includes(pesquisa.toLowerCase()) ||
    (e.fantasia || '').toLowerCase().includes(pesquisa.toLowerCase()) ||
    (e.documento || '').toLowerCase().includes(pesquisa.toLowerCase()) ||
    String(e.id).includes(pesquisa)
  );
  // Ordenar: ativas primeiro, inativas por último, e dentro de cada grupo por fantasia
  const empresasOrdenadas = empresasFiltradas.slice().sort((a, b) => {
    // Ativas primeiro
    if ((a.ativo === false) && (b.ativo !== false)) return 1;
    if ((a.ativo !== false) && (b.ativo === false)) return -1;
    // Ordem alfabética fantasia
    return (a.fantasia || '').localeCompare(b.fantasia || '', 'pt', { sensitivity: 'base' });
  });
  const totalPaginas = Math.ceil(empresasOrdenadas.length / PAGE_SIZE);
  const empresasPaginadas = empresasOrdenadas.slice((pagina - 1) * PAGE_SIZE, pagina * PAGE_SIZE);

  const getImagemUrl = (path) => {
    if (!path) return logo;
    if (path.startsWith('https://')) return path;
    return `https://conexaopix.com.br/docs${path}`;
  };

  const handleBuscarCnpj = async () => {
    const cnpjLimpo = form.documento.replace(/\D/g, '');
    if (cnpjLimpo.length !== 14) {
      setErro('Digite um CNPJ válido para buscar!');
      return;
    }
    setBuscandoCnpj(true);
    setErro('');
    try {
      const res = await fetch(`${API_URL}/proxy-cnpj/${cnpjLimpo}`);
      const data = await res.json();
      if (data.status !== 'OK') {
        setErro('CNPJ não encontrado ou bloqueado pela ReceitaWS.');
        setBuscandoCnpj(false);
        return;
      }
      setForm(f => ({
        ...f,
        documento: data.cnpj ? maskCpfCnpj(data.cnpj.replace(/\D/g, '')) : f.documento,
        razao: data.nome || f.razao,
        fantasia: data.fantasia || f.fantasia,
        email: data.email || f.email,
        telefone: data.telefone ? data.telefone.replace(/[^0-9]/g, '').slice(0, 11) : f.telefone,
        cep: data.cep ? maskCep(data.cep.replace(/\D/g, '')) : f.cep,
        rua: data.logradouro || f.rua,
        numero: data.numero || f.numero,
        complemento: data.complemento || f.complemento,
        bairro: data.bairro || f.bairro,
        cidade: data.municipio || f.cidade,
        estado: data.uf || f.estado,
      }));
    } catch (err) {
      setErro('Erro ao buscar CNPJ na ReceitaWS.');
    }
    setBuscandoCnpj(false);
  };

  const handleBuscarCep = async () => {
    const cepLimpo = form.cep.replace(/\D/g, '');
    if (cepLimpo.length !== 8) {
      setErro('Digite um CEP válido para buscar!');
      return;
    }
    setBuscandoCep(true);
    setErro('');
    try {
      const res = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
      const data = await res.json();
      if (data.erro) {
        setErro('CEP não encontrado.');
        setBuscandoCep(false);
        return;
      }
      setForm(f => ({
        ...f,
        cep: data.cep ? maskCep(data.cep.replace(/\D/g, '')) : f.cep,
        rua: data.logradouro || f.rua,
        complemento: data.complemento || f.complemento,
        bairro: data.bairro || f.bairro,
        cidade: data.localidade || data.cidade || f.cidade,
        estado: data.uf || data.estado || f.estado,
        ibge: data.ibge || f.ibge,
      }));
    } catch (err) {
      setErro('Erro ao buscar CEP na ViaCEP.');
    }
    setBuscandoCep(false);
  };

  // Buscar tabelas de preços
  const fetchTabelasPrecos = async (empresaId) => {
    try {
      const res = await fetch(`${API_URL}/tabelas_precos?empresa_id=${empresaId}`);
      const data = await res.json();
      setTabelasPrecos(Array.isArray(data) ? data : []);
    } catch {
      setTabelasPrecos([]);
    }
  };

  // Adicionar logs no useEffect de inclusão automática
  useEffect(() => {
    async function incluirUsuarioRevenda() {
      if (
        modalInfo &&
        usuario.id !== 1 &&
        modalInfo.empresa_id &&
        modalInfo.rev_carencia !== undefined &&
        modalInfo.rev_validade !== undefined &&
        modalInfo.app_grupo_id
      ) {
        try {
          console.log('usuario.id:', usuario.id);
          const payload = {
            empresa_id: modalInfo.empresa_id,
            usuario_id: usuario.usr_codigo || usuario.id,
            funcionario: 'R',
            usr_carencia: modalInfo.rev_carencia,
            usr_validade: modalInfo.rev_validade,
            app_grupo_id: modalInfo.app_grupo_id,
            ativo: true
          };
          console.log('Enviando inclusão automática para empresas_usuarios:', payload);
          const resp = await fetch(`${API_URL}/empresas_usuarios`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
          const respData = await resp.json();
          console.log('Resposta da inclusão automática empresas_usuarios:', resp.status, respData);
        } catch (err) {
          console.error('Erro ao incluir usuário revenda automaticamente:', err);
        }
      }
    }
    incluirUsuarioRevenda();
    // eslint-disable-next-line
  }, [modalInfo]);

  if (paginaUsuarios) {
    return (
      <EmpresaUsuariosPage
        usuario={usuario}
        empresa={empresa}
        empresaSelecionada={empresaSelecionada}
        onVoltar={() => setPaginaUsuarios(false)}
        onSair={onSair}
      />
    );
  }

  if (paginaFinalizadoras) {
    return (
      <EmpresaFinalizadorasPage
        usuario={usuario}
        empresa={empresaSelecionada}
        onVoltar={() => setPaginaFinalizadoras(false)}
        onSair={onSair}
      />
    );
  }

  if (paginaLicencas) {
    return (
      <EmpresaLicencasPage
        usuario={usuario}
        empresa={empresaSelecionada}
        onVoltar={() => setPaginaLicencas(false)}
        onSair={onSair}
      />
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header usuario={usuario} empresa={empresa} onVoltar={onVoltar} onSair={onSair} />
      <div className="max-w-5xl mx-auto mt-10 bg-white rounded-lg shadow-lg p-6 relative">
        <h2 className="text-2xl font-bold text-blue-700 mb-6">Empresas</h2>
        <div className="mb-6 flex justify-start">
          <input
            type="text"
            value={pesquisa}
            onChange={e => { setPesquisa(e.target.value); setPagina(1); }}
            placeholder="Pesquisar por id, razão, fantasia ou documento..."
            className="border rounded px-3 py-2 w-full max-w-xs"
          />
        </div>
        {erro && <div className="text-red-600 mb-4">{erro}</div>}
        {loading ? (
          <div>Carregando...</div>
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {empresasPaginadas.map(e => (
                <div key={e.id} className={`bg-blue-50 rounded-lg shadow flex flex-col p-4 relative border border-blue-200 ${e.ativo === false ? 'opacity-50 grayscale' : ''}`}>
                  {e.path_imagem ? (
                    <img src={getImagemUrl(e.path_imagem)} alt={e.fantasia} className="w-16 h-16 object-cover rounded mx-auto mb-2 border shadow" />
                  ) : (
                    <img src={logo} alt="Logo" className="w-16 h-16 object-cover rounded mx-auto mb-2 border shadow" />
                  )}
                  <div className="flex items-center justify-between mb-2">
                    <span className="font-bold text-blue-800 text-lg">{e.fantasia}</span>
                    <div className="flex space-x-2">
                      <button onClick={() => abrirModal(e)} title="Editar" className="text-blue-600 hover:text-blue-900">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536M9 13l6-6 3 3-6 6H9v-3z" /></svg>
                      </button>
                      <button onClick={() => handleDelete(e.id)} title="Excluir" className="text-red-600 hover:text-red-900">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                      </button>
                    </div>
                  </div>
                  <div className="text-gray-700 mb-1"><b>Razão:</b> {e.razao}</div>
                  {(() => {
                    const docInfo = getDocumentoLabelValor(e.documento);
                    return (
                      <div className="text-gray-700 mb-1"><b>{docInfo.label}:</b> {docInfo.valor}</div>
                    );
                  })()}
                  <div className="text-gray-700 mb-1"><b>Email:</b> {e.email}</div>
                  <div className="text-gray-700 mb-1"><b>Telefone:</b> {e.telefone ? maskTelefone(e.telefone) : ''}</div>
                  <div className="text-gray-700 mb-1"><b>Cidade:</b> {e.cidade || (e.endereco && e.endereco.cidade) || ''}</div>
                  <div className="text-gray-700 mb-1 flex justify-between items-center">
                    <span><b>Estado:</b> {e.estado || (e.endereco && e.endereco.estado) || ''}</span>
                    <span className="text-xs text-gray-400 font-bold">{e.id}</span>
                  </div>
                  <div className="flex justify-center space-x-4 mt-2 pt-2 border-t border-blue-200">
                    <button 
                      className="text-blue-600 hover:text-blue-900" 
                      title="Usuários"
                      onClick={() => {
                        setEmpresaSelecionada(e);
                        setPaginaUsuarios(true);
                      }}
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                      </svg>
                    </button>
                    <button className="text-green-600 hover:text-green-900" title="Licenças" onClick={() => { setEmpresaSelecionada(e); setPaginaLicencas(true); }}>
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                      </svg>
                    </button>
                    <button className="text-purple-600 hover:text-purple-900" title="Finalizadoras" onClick={() => { setEmpresaSelecionada(e); setPaginaFinalizadoras(true); }}>
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                      </svg>
                    </button>
                    {e.revenda === true && (
                      <button
                        className="text-gray-600 hover:text-gray-900"
                        title="Configuração"
                        onClick={async () => {
                          // Buscar dados atualizados da empresa antes de abrir o modal
                          try {
                            const res = await fetch(`${API_URL}/pessoas/${e.id}`);
                            const empresaAtualizada = await res.json();
                            setEmpresaSelecionada(empresaAtualizada);
                            setShowConfiguracao(true);
                          } catch {
                            setEmpresaSelecionada(e);
                            setShowConfiguracao(true);
                          }
                        }}
                      >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M12 15.5A3.5 3.5 0 1 0 12 8.5a3.5 3.5 0 0 0 0 7zm7.03-2.11a1 1 0 0 0 .21-1.09l-1.07-1.85a1 1 0 0 1 .11-1.13l.81-.81a1 1 0 0 0 0-1.41l-1.42-1.42a1 1 0 0 0-1.41 0l-.81.81a1 1 0 0 1-1.13.11l-1.85-1.07a1 1 0 0 0-1.09.21l-.65.65a1 1 0 0 1-1.18.18l-2.12-.85a1 1 0 0 0-1.31.48l-.5.87a1 1 0 0 0 .18 1.18l.65.65a1 1 0 0 1 .21 1.09l-1.07 1.85a1 1 0 0 0 .21 1.09l.65.65a1 1 0 0 1 .18 1.18l-.85 2.12a1 1 0 0 0 .48 1.31l.87.5a1 1 0 0 0 1.18-.18l.65-.65a1 1 0 0 1 1.09-.21l1.85 1.07a1 1 0 0 0 1.09-.21l.65-.65a1 1 0 0 1 1.18-.18l2.12.85a1 1 0 0 0 1.31-.48l.5-.87a1 1 0 0 0-.18-1.18l-.65-.65a1 1 0 0 1-.21-1.09l1.07-1.85z" />
                        </svg>
                      </button>
                    )}
                  </div>
                </div>
              ))}
              {empresasPaginadas.length === 0 && (
                <div className="col-span-full text-center py-8 text-gray-500">Nenhuma empresa encontrada.</div>
              )}
            </div>
            {totalPaginas > 1 && (
              <div className="flex justify-center items-center mt-8 mb-2 w-full">
                {Array.from({ length: totalPaginas }, (_, i) => (
                  <button
                    key={i + 1}
                    className={`w-10 h-10 flex items-center justify-center rounded transition font-semibold border mx-0.5
                      ${pagina === i + 1 ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-blue-600 border-blue-200 hover:bg-blue-50'}`}
                    onClick={() => setPagina(i + 1)}
                  >
                    {i + 1}
                  </button>
                ))}
              </div>
            )}
          </>
        )}
        {/* Botão flutuante adicionar */}
        <button
          onClick={() => abrirModal()}
          className="fixed bottom-8 right-8 bg-blue-600 text-white rounded-full shadow-lg w-16 h-16 flex items-center justify-center text-3xl hover:bg-blue-700 transition z-50"
          title="Adicionar Empresa"
        >
          +
        </button>
        {/* Modal de inclusão/edição */}
        {modalAberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-2xl relative max-h-[90vh] overflow-y-auto">
              {alerta && (
                <div className="fixed inset-0 flex items-center justify-center z-50">
                  <div className="bg-white border border-danger-600 shadow-lg rounded-lg px-6 py-4 text-center" style={{ minWidth: 300 }}>
                    <div className="mb-2 text-lg font-bold text-red-600">{alerta}</div>
                    <button className="btn btn-danger bg-red-600 text-white px-4 py-2 rounded mt-2" onClick={() => { setAlerta(null); fecharModal(); }}>Fechar</button>
                  </div>
                </div>
              )}
              <button onClick={fecharModal} className="absolute top-2 right-2 text-gray-400 hover:text-red-600 text-2xl">&times;</button>
              <h3 className="text-xl font-bold text-blue-700 mb-4">{editando ? 'Editar Empresa' : 'Nova Empresa'}</h3>
              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Card 1: Dados principais */}
                <div className="bg-blue-50 rounded-lg shadow p-4 border border-blue-200 mb-4">
                  <h4 className="font-bold text-blue-700 mb-3">Dados da Empresa</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="relative">
                      <label className="block text-sm font-medium text-gray-700 mb-1">CNPJ / CPF*</label>
                      <input
                        name="documento"
                        value={form.documento}
                        onChange={handleChange}
                        className="border rounded px-3 py-2 w-full pr-10"
                        required
                        maxLength={18}
                        readOnly={editando}
                      />
                      {form.documento.replace(/\D/g, '').length === 14 && (
                        <button
                          type="button"
                          className="absolute right-2 top-8 text-blue-600 hover:text-blue-900"
                          onClick={handleBuscarCnpj}
                          disabled={buscandoCnpj}
                          title="Buscar dados do CNPJ na ReceitaWS"
                        >
                          <FaSearch />
                        </button>
                      )}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">IE / RG</label>
                      <input name="ie_rg" value={form.ie_rg} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Indicador IE</label>
                      <select name="indicador_ie" value={form.indicador_ie} onChange={handleChange} className="border rounded px-3 py-2 w-full">
                        <option value="">Selecione</option>
                        <option value="1">Contribuinte</option>
                        <option value="2">Isento do ICMS</option>
                        <option value="9">Não Contribuinte</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Razão / Nome*</label>
                      <input name="razao" value={form.razao} onChange={handleChange} className="border rounded px-3 py-2 w-full" required />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Fantasia*</label>
                      <input name="fantasia" value={form.fantasia} onChange={handleChange} className="border rounded px-3 py-2 w-full" required />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                      <input name="email" value={form.email} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Telefone</label>
                      <input name="telefone" value={form.telefone} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Logo (upload)</label>
                      <input type="file" accept="image/*" onChange={handleFileChange} className="border rounded px-3 py-2 w-full" />
                      {form.path_imagem && (
                        <div className="mt-2 flex items-center">
                          <img src={getImagemUrl(form.path_imagem)} alt="Preview" className="w-20 h-20 object-cover rounded shadow border" />
                        </div>
                      )}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Interface</label>
                      <select name="interface" value={form.interface} onChange={handleChange} className="border rounded px-3 py-2 w-full">
                        <option value="">Selecione</option>
                        <option value="1">mPm+</option>
                        <option value="3">SmartTEF v1</option>
                        <option value="5">SmartTEF v2</option>
                        <option value="8">MobTEF v1</option>
                        <option value="9">MobTEF v1 Posto</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Token</label>
                      <input name="token" value={form.token} readOnly className="border rounded px-3 py-2 w-full bg-gray-100" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Taxa Serviço</label>
                      <input name="taxa_servico" value={form.taxa_servico} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Taxa Percentual</label>
                      <input name="taxa_percentual" value={form.taxa_percentual} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Cash Percentual</label>
                      <input name="cash_percentual" value={form.cash_percentual} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                    </div>
                    <div className="flex items-center space-x-2">
                      <input type="checkbox" name="autopagamento" checked={!!form.autopagamento} onChange={e => setForm(f => ({ ...f, autopagamento: e.target.checked }))} />
                      <label className="text-sm font-medium text-gray-700">Auto Pagamento</label>
                    </div>
                    <div className="flex items-center space-x-2">
                      <input type="checkbox" name="gerenciar_impressao" checked={!!form.gerenciar_impressao} onChange={e => setForm(f => ({ ...f, gerenciar_impressao: e.target.checked }))} />
                      <label className="text-sm font-medium text-gray-700">Gerenciar Impressão</label>
                    </div>
                    {editando && (
                      <>
                        <div className="flex items-center space-x-2">
                          <input type="checkbox" name="utiliza_tabelas_precos" checked={!!form.utiliza_tabelas_precos} onChange={handleChange} />
                          <label className="text-sm font-medium text-gray-700">Utiliza Tabelas</label>
                        </div>
                        {form.utiliza_tabelas_precos && (
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Tabela de Preços</label>
                            <div className="flex flex-col gap-1">
                              {tabelasPrecos.map(tab => (
                                <label key={tab.id} className="flex items-center gap-2">
                                  <input
                                    type="checkbox"
                                    value={tab.id}
                                    checked={form.tabelas_precos.includes(String(tab.id))}
                                    onChange={e => {
                                      const checked = e.target.checked;
                                      const value = e.target.value;
                                      setForm(f => {
                                        let novaLista = f.tabelas_precos || [];
                                        if (checked) {
                                          novaLista = [...novaLista, value];
                                        } else {
                                          novaLista = novaLista.filter(id => id !== value);
                                        }
                                        return { ...f, tabelas_precos: novaLista };
                                      });
                                    }}
                                  />
                                  {tab.nome}
                                </label>
                              ))}
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
                {/* Card 2: Endereço */}
                <div className="bg-blue-50 rounded-lg shadow p-4 border border-blue-200 mb-4">
                  <h4 className="font-bold text-blue-700 mb-3">Endereço</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="relative">
                      <label className="block text-sm font-medium text-gray-700 mb-1">CEP</label>
                      <input
                        name="cep"
                        value={form.cep}
                        onChange={handleChange}
                        className="border rounded px-3 py-2 w-full pr-10"
                        maxLength={9}
                      />
                      {form.cep.replace(/\D/g, '').length === 8 && (
                        <button
                          type="button"
                          className="absolute right-2 top-8 text-blue-600 hover:text-blue-900"
                          onClick={handleBuscarCep}
                          disabled={buscandoCep}
                          title="Buscar dados do CEP na ViaCEP"
                        >
                          <FaSearch />
                        </button>
                      )}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Endereço</label>
                      <input name="rua" value={form.rua} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Número</label>
                      <input name="numero" value={form.numero} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Complemento</label>
                      <input name="complemento" value={form.complemento} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Bairro</label>
                      <input name="bairro" value={form.bairro} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Cidade</label>
                      <input name="cidade" value={form.cidade} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Estado</label>
                      <input name="estado" value={form.estado} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">IBGE</label>
                      <input name="ibge" value={form.ibge} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                    </div>
                  </div>
                </div>
                {/* Card 3: Certificado e CSC */}
                <div className="bg-blue-50 rounded-lg shadow p-4 border border-blue-200 mb-4">
                  <h4 className="font-bold text-blue-700 mb-3">Certificado e CSC</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Senha Certificado</label>
                      <input name="senha_cert" value={form.senha_cert} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Vencimento Certificado</label>
                      <input name="vencimento_cert" value={form.vencimento_cert} onChange={handleChange} type="date" className="border rounded px-3 py-2 w-full" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Upload Certificado</label>
                      <input type="file" name="certificado" accept=".pfx,.crt,.cer" onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">ID CSC</label>
                      <input name="csc_id" value={form.csc_id} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">CSC</label>
                      <input name="csc" value={form.csc} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                    </div>
                  </div>
                </div>
                {erro && <div className="text-red-600 font-bold mb-2 text-center">{erro}</div>}
                <div className="flex justify-end space-x-2 mt-2">
                  <button type="button" onClick={fecharModal} className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition">Cancelar</button>
                  <button type="submit" disabled={uploading || salvando || !!erro} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition">{uploading ? 'Enviando imagem...' : salvando ? 'Salvando...' : editando ? 'Salvar' : 'Cadastrar'}</button>
                </div>
              </form>
            </div>
          </div>
        )}
        {/* Modal de confirmação de exclusão */}
        {confirmarExclusao.aberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md relative">
              <h3 className="text-xl font-bold text-blue-700 mb-4">Confirmar Desativação</h3>
              <p>Tem certeza que deseja desativar esta empresa?<br/>Ela não será excluída, apenas ficará inativa no sistema.</p>
              <div className="flex justify-end space-x-2 mt-6">
                <button onClick={cancelarRemocao} className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition">Cancelar</button>
                <button onClick={confirmarRemocao} className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition">Desativar</button>
              </div>
            </div>
          </div>
        )}
        {modalInfo && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
              <h3 className="text-xl font-bold text-blue-700 mb-4">Informações de Acesso</h3>
              
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">EMPRESA</label>
                  <div className="flex items-center mt-1">
                    <input
                      type="text"
                      value={`ID: ${modalInfo.empresa_id}`}
                      readOnly
                      className="flex-1 border rounded px-3 py-2 bg-gray-50"
                    />
                    <button
                      onClick={() => navigator.clipboard.writeText(modalInfo.empresa_id)}
                      className="ml-2 p-2 text-gray-600 hover:text-blue-600"
                      title="Copiar ID da Empresa"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" />
                        <path d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                      </svg>
                    </button>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">USUÁRIO</label>
                  <div className="flex items-center mt-1">
                    <input
                      type="text"
                      value={`ID: ${modalInfo.usuario_id}`}
                      readOnly
                      className="flex-1 border rounded px-3 py-2 bg-gray-50"
                    />
                    <button
                      onClick={() => navigator.clipboard.writeText(modalInfo.usuario_id)}
                      className="ml-2 p-2 text-gray-600 hover:text-blue-600"
                      title="Copiar ID do Usuário"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" />
                        <path d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                      </svg>
                    </button>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">SENHA</label>
                  <div className="flex items-center mt-1">
                    <input
                      type="text"
                      value={modalInfo.senha}
                      readOnly
                      className="flex-1 border rounded px-3 py-2 bg-gray-50"
                    />
                    <button
                      onClick={() => navigator.clipboard.writeText(modalInfo.senha)}
                      className="ml-2 p-2 text-gray-600 hover:text-blue-600"
                      title="Copiar Senha"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" />
                        <path d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                      </svg>
                    </button>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">TOKEN</label>
                  <div className="flex items-center mt-1">
                    <input
                      type="text"
                      value={modalInfo.token}
                      readOnly
                      className="flex-1 border rounded px-3 py-2 bg-gray-50"
                    />
                    <button
                      onClick={() => navigator.clipboard.writeText(modalInfo.token)}
                      className="ml-2 p-2 text-gray-600 hover:text-blue-600"
                      title="Copiar Token"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" />
                        <path d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              <div className="mt-6 flex justify-between items-center">
                <button
                  onClick={() => navigator.clipboard.writeText(
                    `EMPRESA: ${modalInfo.empresa_id}\nUSUÁRIO: ${modalInfo.usuario_id}\nSENHA: ${modalInfo.senha}\nTOKEN: ${modalInfo.token}`
                  )}
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Copiar Tudo
                </button>

                <div className="flex space-x-2">
                  <button
                    className="p-2 text-green-600 hover:text-green-700"
                    title="Enviar por WhatsApp"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                    </svg>
                  </button>
                  <button
                    className="p-2 text-blue-600 hover:text-blue-700"
                    title="Enviar por Email"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                    </svg>
                  </button>
                </div>
              </div>

              <button
                onClick={() => setModalInfo(null)}
                className="mt-4 w-full px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
              >
                Fechar
              </button>
            </div>
          </div>
        )}
        {showConfiguracao && empresaSelecionada && (
          <RevendaConfiguracaoPage empresa={empresaSelecionada} onClose={() => setShowConfiguracao(false)} />
        )}
      </div>
    </div>
  );
}

export default RevendaEmpresasPage; 